import { render } from "./index.vue?vue&type=template&id=3e32c634"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/online-shop-service/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e32c634"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e32c634', __exports__)) {
    api.reload('3e32c634', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3e32c634", () => {
    api.rerender('3e32c634', render)
  })

}


export default __exports__